import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

/**
 * Self-healing: if the device is stuck on builtin or a stale bundle,
 * downloads and sets the latest OTA bundle so it activates on next launch.
 * Fire-and-forget — failures are logged, not thrown.
 */
export async function attemptOTARecovery(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  if (!Capacitor.isPluginAvailable('CapacitorUpdater')) {
    console.warn('[OTA Recovery] CapacitorUpdater plugin not available in this binary');
    return;
  }

  try {
    const current = await CapacitorUpdater.current();
    const isBuiltin = current?.bundle?.id === 'builtin';

    const latest = await CapacitorUpdater.getLatest();
    const needsUpdate = latest?.version && latest.version !== current?.bundle?.version;

    if (!needsUpdate && !isBuiltin) {
      console.log('[OTA Recovery] Bundle is current');
      return;
    }

    if (!latest?.url) {
      console.log('[OTA Recovery] No download URL available');
      return;
    }

    console.log('[OTA Recovery] Downloading latest bundle...');
    const downloaded = await CapacitorUpdater.download({
      url: latest.url,
      version: latest.version ?? 'recovery',
    });

    await CapacitorUpdater.set(downloaded);
    console.log('[OTA Recovery] Bundle set for next launch:', downloaded.id);
  } catch (e: any) {
    const msg = e?.message ?? String(e);
    if (!msg.includes('No new version')) {
      console.warn('[OTA Recovery] Failed:', msg);
    }
  }
}
